// extracted by mini-css-extract-plugin
export default {"cls1":"Q7SoXOy9mGJxjKnR2zh7","cls2":"EDXPoPFEBBRf_73EewYD Q7SoXOy9mGJxjKnR2zh7","isPhone":"KDdtlzb7iFyC4vufG5fo","compact":"w5odLKuyTgYSMySIKu8a"};